import type { SfCart } from '@vue-storefront/unified-data-model';
import { toRefs } from '@vueuse/shared';
import type { UseCartReturn, UseCartState, FetchCart } from '~/composables/useCart/types';
import { useSdk } from '~/sdk';

/**
 * @description Composable for managing cart.
 * @returns {@link UseCartReturn}
 * @example
 * const { data, loading } = useCart();
 */
export const useCart = () => {
  const cart = useState('cart', () => [])

  const state = useState<UseCartState>('useCart', () => ({
    data: null,
    loading: false,
  }));

  /**
   * @description Function for fetching the cart.
   * @example
   * getCart();
   */
  const fetchCart: FetchCart = async () => {
    state.value.loading = true;
    try {
      const { data, error } = await useAsyncData<SfCart>(() => useSdk().commerce.getCart());
      useHandleError(error.value);
      state.value.data = data.value;
      return data;
    } catch (error) {
      throw new Error(error as string);
    } finally {
      state.value.loading = false;
    }
  };

  const fetchCartById = async () => {
    state.value.loading = true;
    const { user: userData} = useUserSession();

    try {
      const { data, error } = await useAsyncData(() => useSdk().magento.cart(userData.value?.cartId));
      useHandleError(error.value);
      //state.value.data = data.value;
      return data;
    } catch (error) {
      throw new Error(error as string);
    } finally {
      state.value.loading = false;
    }
  };

  const addToCart = async (quoteId: string, sku: string, qty: string) => {
    return await useSdk().magento.addToCart(quoteId, sku, qty);
  };

  return {
    fetchCart: fetchCart,
    cart,
    addToCart,
    fetchCartById: fetchCartById,
    ...toRefs(state.value),
  };
};
